module.exports = __webpack_public_path__ + "static/media/orto.68a172aa.jpeg";